/* hb-sticky.js: Kaufleiste fuer sections/hb-sticky-atc.liquid. Ohne JS bleibt die Leiste ausgeblendet. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-hb-sticky]');
  if (!bar || bar.getAttribute('data-hb-init')) { return; }
  bar.setAttribute('data-hb-init', '1');

  var form = document.querySelector('form[action*="/cart/add"]');
  var origBtn = form && (form.querySelector('[data-action="add-to-cart"]') || form.querySelector('button[type="submit"]'));
  if (!form || !origBtn) { return; }

  var btn = bar.querySelector('[data-hb-sticky-btn]');
  var optEl = bar.querySelector('[data-hb-sticky-opt]');
  var priceEl = bar.querySelector('[data-hb-sticky-price]');
  var defaultLabel = btn.textContent;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var buyVisible = true;      // Original-Knopf im Bild
  var buyBelow = false;       // Original-Knopf liegt unterhalb des Bildschirms (noch nicht erreicht)
  var footerVisible = false;
  var shown = false;

  function render() {
    var want = !buyVisible && !buyBelow && !footerVisible;
    if (want === shown) { return; }
    shown = want;
    if (want) {
      bar.hidden = false;
      // erst nach dem Einblenden der Box die Klasse setzen, damit die Transition laeuft
      window.requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } else {
      bar.classList.remove('is-visible');
      window.setTimeout(function () { if (!shown) { bar.hidden = true; } }, reduce ? 0 : 280);
    }
  }

  /* ---- Sichtbarkeit: Kaufen-Knopf und Footer ----
     Gemessen per getBoundingClientRect bei Scroll/Resize (rAF-gedrosselt). Ein reiner IntersectionObserver
     meldet nichts, wenn man mit einem Sprung am Knopf vorbei scrollt (unten -> oben ohne "sichtbar" dazwischen). */
  var footer = document.querySelector('#shopify-section-footer, footer.Footer, .Footer');
  var ticking = false;
  function measure() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = origBtn.getBoundingClientRect();
    buyVisible = r.bottom > 0 && r.top < vh;
    buyBelow = r.top >= vh;
    if (footer) { var f = footer.getBoundingClientRect(); footerVisible = f.top < vh && f.bottom > 0; }
    render();
  }
  function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(measure); } }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  if ('ResizeObserver' in window) { new ResizeObserver(schedule).observe(document.body); }
  measure();

  /* ---- Auswahl und Preis synchron halten ---- */
  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function syncSelection() {
    var sel = document.querySelector('[data-hb-opts] .hb-opt.is-selected');
    if (sel) {
      var nameEl = sel.querySelector('.hb-opt__name');
      var name = nameEl && nameEl.firstChild ? nameEl.firstChild.textContent.replace(/\s+/g, ' ').trim() : '';
      var now = text(sel.querySelector('[data-hb-now]'));
      if (name && optEl) { optEl.textContent = name; }
      if (now && priceEl) { priceEl.textContent = now; }
    } else {
      var q = form.querySelector('input[name="quantity"]');
      if (q && optEl) { optEl.textContent = (parseInt(q.value, 10) || 1) + ' Flaschen'; }
      var pr = document.querySelector('.ProductMeta__Price');
      if (pr && priceEl && parseInt(q && q.value, 10) === 1) { priceEl.textContent = text(pr); }
    }
    var off = origBtn.disabled;
    btn.disabled = off;
    btn.textContent = off ? text(origBtn) || 'Ausverkauft' : defaultLabel;
  }

  var opts = document.querySelector('[data-hb-opts]');
  if (opts && 'MutationObserver' in window) {
    new MutationObserver(syncSelection).observe(opts, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(syncSelection).observe(origBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
  ['change', 'input', 'click'].forEach(function (ev) {
    form.addEventListener(ev, function () { window.setTimeout(syncSelection, 80); });
  });
  document.addEventListener('variant:changed', function () { window.setTimeout(syncSelection, 80); });
  syncSelection();

  /* ---- Kaufen: den echten Knopf ausloesen (Ajax-Warenkorb des Themes) ---- */
  btn.addEventListener('click', function () {
    if (btn.disabled || origBtn.disabled) { return; }
    btn.setAttribute('aria-busy', 'true');
    origBtn.click();
    window.setTimeout(function () { btn.removeAttribute('aria-busy'); }, 1500);
  });
})();
